
// <div local-controller='MainController as mc' locals='{x: "test", y: 42}'></div>


angular.module('admin')
.directive('localController', function($controller) {
  return {
    scope: true,
    priority: 10,
    link: {
    	pre: function(scope, elem, attrs) {
	      var locals = scope.$eval(attrs.locals);
	      angular.extend(locals, {$scope: scope});
	      var ctrlas = attrs.localController.split(/ +as +/)
	      var ctrl = $controller(ctrlas[0], locals);
	      scope[ctrlas[1]] = ctrl;
				if (attrs.localControllerInit) {scope.$eval(attrs.localControllerInit);}
	      console.log('localController', ctrlas[1], ctrl);
	    }
	}
  };
});